import dayjs from 'dayjs'

function getTodaysDate () {
  const result = dayjs().format('YYYY-MM-DD')
  return result
}

function getCleanDate (date) {
  return dayjs(date).format('YYYY-MM-DD')
}

export { getTodaysDate, getCleanDate }
